<template>
  <div class="d-flex">
    <div class="flex-fill">
      <div class="d-flex align-items-baseline">
        <sds-hmis-label :product="product"></sds-hmis-label>
        <div
          class="ms-3 small"
          :class="search == product.local_id ? 'text-primary' : 'text-muted'"
          v-if="product.local_id"
          v-text="local_id"
        ></div>
      </div>
      <h5 class="m-0 mt-2" v-html="name"></h5>
      <div :class="{ 'text-primary': search == product.sds_number }">
        SDS No. <span v-text="product.sds_number"></span>
      </div>
    </div>
    <div class="d-flex flex-column align-items-end">
      <sds-ghs-label :product="product"></sds-ghs-label>
      <span class="m-0 mt-2 fs-5">{{ product.signal_word | capitalize }}</span>
    </div>
  </div>
</template>

<script>
import SdsGhsLabel from "./SdsGhsLabel.vue";
import SdsHmisLabel from "./SdsHmisLabel.vue";
export default {
  components: { SdsGhsLabel, SdsHmisLabel },
  name: "SdsProduct",
  props: {
    product: {
      type: Object,
    },
    search: {
      type: String,
      default: "",
    },
  },
  computed: {
    local_id() {
      return ("000000" + this.product.local_id).slice(-6);
    },
    name() {
      return this.product.local_name
        ? this.product.local_name
        : this.product.name;
    },
  },
};
</script>
